import { createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "language-box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_view = _resolveComponent("router-view");
  const _component_a_select_option = _resolveComponent("a-select-option");
  const _component_a_select = _resolveComponent("a-select");
  const _component_a_config_provider = _resolveComponent("a-config-provider");
  return _openBlock(), _createBlock(_component_a_config_provider, {
    locale: $data.locale
  }, {
    default: _withCtx(() => [_cache[3] || (_cache[3] = _createElementVNode("div", {
      id: "nav"
    }, null, -1)), _createVNode(_component_router_view, null, {
      default: _withCtx(({
        Component
      }) => [_createVNode(_Transition, null, {
        default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(Component)))]),
        _: 2
      }, 1024)]),
      _: 1
    }), _withDirectives(_createElementVNode("div", _hoisted_1, [_createVNode(_component_a_select, {
      value: $data.language,
      "onUpdate:value": _cache[0] || (_cache[0] = $event => $data.language = $event),
      style: {
        "width": "160px"
      },
      onChange: $options.onLanguageChange
    }, {
      default: _withCtx(() => [_createVNode(_component_a_select_option, {
        value: "zhCN"
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode("中文")])),
        _: 1
      }), _createVNode(_component_a_select_option, {
        value: "enUS"
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("English")])),
        _: 1
      })]),
      _: 1
    }, 8, ["value", "onChange"])], 512), [[_vShow, $data.showLanguage]])]),
    _: 1
  }, 8, ["locale"]);
}